let getMapping = require('./mapping');
const supportedEnvironments = ['prod', 'dev'];

async function getWriteKey(tenant, country, environment) {
    validateInput(tenant, country, environment);
    const writeKeys = await getMapping();
    const environmentKey = environment.toLowerCase();
    const tenantKey = tenant.toLowerCase();
    const countryKey = country.toLowerCase();
    const environmentData = writeKeys[environmentKey];

    if (!environmentData) {
        throw new Error(`Not supported environment ${environment}`);
    }

    const tenantData = environmentData[tenantKey];

    if (!tenantData) {
        throw new Error(`Not supported tenant ${tenant}`);
    }

    if (environmentKey === 'prod') {
        const writeKey = tenantData[countryKey];
        if (writeKey) {
            return writeKey;
        }

        const defaultWriteKey = tenantData['default'];

        if (defaultWriteKey) {
            return defaultWriteKey;
        }

        throw new Error(`Not supported country ${country}`);
    } else {
        const prodData = writeKeys['prod'];
        const tenantProdWriteKeys = prodData[tenantKey];
        if (!tenantProdWriteKeys || !(tenantProdWriteKeys[countryKey] || tenantProdWriteKeys['default'])) {
            console.warn(
                `Tracking initialization will fail in production. WriteKey for prod environment is not available for tenant: ${tenant}, country: ${country}.`
            );
        }
    }

    if (typeof tenantData === 'object') {
        const writeKey = tenantData[countryKey];
        if (writeKey) {
            return writeKey;
        }

        throw new Error(`Not supported country ${country}`);
    }

    return tenantData;
}

function validateInput(tenant, country, environment) {
    if (!tenant) {
        throw new Error('Missing tenant');
    }

    if (!country) {
        throw new Error('Missing country');
    }

    if (country.length != 2) {
        throw new Error(`Invalid country format ${country} should be 2 capital letters`);
    }

    if (!environment) {
        throw new Error('Missing environment');
    }

    if (supportedEnvironments.indexOf(environment.toLowerCase()) < 0) {
        throw new Error(
            `Not supported environment ${environment}, supported environments ${supportedEnvironments.join(', ')}`
        );
    }
}

module.exports = getWriteKey;
